import { defineFcm } from '../shared/factory';

export const FCM_CORGI_PERIMETERX_SENSOR_SCRIPT_ENABLED = defineFcm('corgi_perimeterx_sensor_script_enabled')
	.asBoolean()
	.withDefault(true) // enabled by default for security
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'corgi',
		description: `Used to enable/disable the adding of the perimeterX sensor script in the server-rendered HTML.
		This does not disable the nginx plugin, which can still block requests even if this is disabled.
		For security reasons, this is enabled by default`,
		import: false,
	});
